// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file fleet.proto (package fleet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file fleet.proto.
 */
export const file_fleet: GenFile = /*@__PURE__*/
  fileDesc("CgtmbGVldC5wcm90bxIFZmxlZXQiUAoOVmlld3BvcnRCb3VuZHMSDgoGbmVfbGF0GAEgASgBEg4KBm5lX2xuZxgCIAEoARIOCgZzd19sYXQYAyABKAESDgoGc3dfbG5nGAQgASgBIokBCgpEcm9uZVN0YXRlEgoKAmlkGAEgASgJEgsKA2xhdBgCIAEoARILCgNsbmcYAyABKAESCwoDYWx0GAQgASgCEg8KB2hlYWRpbmcYBSABKAISDwoHYmF0dGVyeRgGIAEoAhIRCgljb25uZWN0ZWQYByABKAgSEwoLbGFzdF91cGRhdGUYCCABKAQiiwEKDVBvc2l0aW9uRGVsdGESCgoCaWQYASABKAkSEAoDbGF0GAIgASgBSACIAQESEAoDbG5nGAMgASgBSAGIAQESEAoDYWx0GAQgASgCSAKIAQESFAoHaGVhZGluZxgFIAEoAkgDiAEBQgYKBF9sYXRCBgoEX2xuZ0IGCgRfYWx0QgoKCF9oZWFkaW5nIjQKC1NldFZpZXdwb3J0EiUKBmJvdW5kcxgBIAEoCzIVLmZsZWV0LlZpZXdwb3J0Qm91bmRzIgYKBFBpbmcifAoSRmxlZXRDbGllbnRNZXNzYWdlEhIKCm1lc3NhZ2VfaWQYASABKA0SKgoMc2V0X3ZpZXdwb3J0GAIgASgLMhIuZmxlZXQuU2V0Vmlld3BvcnRIABIbCgRwaW5nGAMgASgLMgsuZmxlZXQuUGluZ0gAQgkKB3BheWxvYWQiLQoIU25hcHNob3QSIQoGZHJvbmVzGAEgAygLMhEuZmxlZXQuRHJvbmVTdGF0ZSIuCgVEZWx0YRIlCgd1cGRhdGVzGAEgAygLMhQuZmxlZXQuUG9zaXRpb25EZWx0YSIwCgxEcm9uZUVudGVyZWQSIAoFZHJvbmUYASABKAsyES5mbGVldC5Ecm9uZVN0YXRlIh8KC0Ryb25lRXhpdGVkEhAKCGRyb25lX2lkGAEgASgJIiIKDkRyb25lQ29ubmVjdGVkEhAKCGRyb25lX2lkGAEgASgJIiUKEURyb25lRGlzY29ubmVjdGVkEhAKCGRyb25lX2lkGAEgASgJIicKCEZsZWV0QWNrEhsKE29yaWdpbmFsX21lc3NhZ2VfaWQYASABKA0iKwoKRmxlZXRFcnJvchIMCgRjb2RlGAEgASgJEg8KB21lc3NhZ2UYAiABKAkikgMKEkZsZWV0U2VydmVyTWVzc2FnZRISCgptZXNzYWdlX2lkGAEgASgNEhEKCXRpbWVzdGFtcBgCIAEoBBIjCghzbmFwc2hvdBgDIAEoCzIPLmZsZWV0LlNuYXBzaG90SAASHQoFZGVsdGEYBCABKAsyDC5mbGVldC5EZWx0YUgAEiwKDWRyb25lX2VudGVyZWQYBSABKAsyEy5mbGVldC5Ecm9uZUVudGVyZWRIABIqCgxkcm9uZV9leGl0ZWQYBiABKAsyEi5mbGVldC5Ecm9uZUV4aXRlZEgAEjAKD2Ryb25lX2Nvbm5lY3RlZBgHIAEoCzIVLmZsZWV0LkRyb25lQ29ubmVjdGVkSAASNgoSZHJvbmVfZGlzY29ubmVjdGVkGAggASgLMhguZmxlZXQuRHJvbmVEaXNjb25uZWN0ZWRIABIeCgNhY2sYCSABKAsyDy5mbGVldC5GbGVldEFja0gAEiIKBWVycm9yGAogASgLMhEuZmxlZXQuRmxlZXRFcnJvckgAQgkKB3BheWxvYWQifwoPVGVsZW1ldHJ5VXBkYXRlEhAKCGRyb25lX2lkGAEgASgJEgsKA2xhdBgCIAEoARILCgNsbmcYAyABKAESCwoDYWx0GAQgASgCEg8KB2hlYWRpbmcYBSABKAISDwoHYmF0dGVyeRgGIAEoAhIRCgl0aW1lc3RhbXAYByABKAQiRgoMU3RhdHVzVXBkYXRlEhAKCGRyb25lX2lkGAEgASgJEhEKCWNvbm5lY3RlZBgCIAEoCBIRCgl0aW1lc3RhbXAYAyABKAQicAoPSW50ZXJuYWxNZXNzYWdlEisKCXRlbGVtZXRyeRgBIAEoCzIWLmZsZWV0LlRlbGVtZXRyeVVwZGF0ZUgAEiUKBnN0YXR1cxgCIAEoCzITLmZsZWV0LlN0YXR1c1VwZGF0ZUgAQgkKB3BheWxvYWRiBnByb3RvMw");

/**
 * Viewport bounds for geographic filtering (Mapbox-style)
 *
 * @generated from message fleet.ViewportBounds
 */
export type ViewportBounds = Message<"fleet.ViewportBounds"> & {
  /**
   * Northeast latitude
   *
   * @generated from field: double ne_lat = 1;
   */
  neLat: number;

  /**
   * Northeast longitude
   *
   * @generated from field: double ne_lng = 2;
   */
  neLng: number;

  /**
   * Southwest latitude
   *
   * @generated from field: double sw_lat = 3;
   */
  swLat: number;

  /**
   * Southwest longitude
   *
   * @generated from field: double sw_lng = 4;
   */
  swLng: number;
};

/**
 * Describes the message fleet.ViewportBounds.
 * Use `create(ViewportBoundsSchema)` to create a new message.
 */
export const ViewportBoundsSchema: GenMessage<ViewportBounds> = /*@__PURE__*/
  messageDesc(file_fleet, 0);

/**
 * Drone state for fleet view (minimal, optimized for map rendering)
 *
 * @generated from message fleet.DroneState
 */
export type DroneState = Message<"fleet.DroneState"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: double lat = 2;
   */
  lat: number;

  /**
   * @generated from field: double lng = 3;
   */
  lng: number;

  /**
   * meters
   *
   * @generated from field: float alt = 4;
   */
  alt: number;

  /**
   * degrees (0-360)
   *
   * @generated from field: float heading = 5;
   */
  heading: number;

  /**
   * percentage (0-100)
   *
   * @generated from field: float battery = 6;
   */
  battery: number;

  /**
   * @generated from field: bool connected = 7;
   */
  connected: boolean;

  /**
   * Unix timestamp ms
   *
   * @generated from field: uint64 last_update = 8;
   */
  lastUpdate: bigint;
};

/**
 * Describes the message fleet.DroneState.
 * Use `create(DroneStateSchema)` to create a new message.
 */
export const DroneStateSchema: GenMessage<DroneState> = /*@__PURE__*/
  messageDesc(file_fleet, 1);

/**
 * Position delta for high-frequency updates
 * Only changed fields are sent (check has_* in implementation)
 *
 * @generated from message fleet.PositionDelta
 */
export type PositionDelta = Message<"fleet.PositionDelta"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional double lat = 2;
   */
  lat?: number;

  /**
   * @generated from field: optional double lng = 3;
   */
  lng?: number;

  /**
   * @generated from field: optional float alt = 4;
   */
  alt?: number;

  /**
   * @generated from field: optional float heading = 5;
   */
  heading?: number;
};

/**
 * Describes the message fleet.PositionDelta.
 * Use `create(PositionDeltaSchema)` to create a new message.
 */
export const PositionDeltaSchema: GenMessage<PositionDelta> = /*@__PURE__*/
  messageDesc(file_fleet, 2);

/**
 * Client -> Server messages
 *
 * @generated from message fleet.SetViewport
 */
export type SetViewport = Message<"fleet.SetViewport"> & {
  /**
   * @generated from field: fleet.ViewportBounds bounds = 1;
   */
  bounds?: ViewportBounds;
};

/**
 * Describes the message fleet.SetViewport.
 * Use `create(SetViewportSchema)` to create a new message.
 */
export const SetViewportSchema: GenMessage<SetViewport> = /*@__PURE__*/
  messageDesc(file_fleet, 3);

/**
 * @generated from message fleet.Ping
 */
export type Ping = Message<"fleet.Ping"> & {
};

/**
 * Describes the message fleet.Ping.
 * Use `create(PingSchema)` to create a new message.
 */
export const PingSchema: GenMessage<Ping> = /*@__PURE__*/
  messageDesc(file_fleet, 4);

/**
 * @generated from message fleet.FleetClientMessage
 */
export type FleetClientMessage = Message<"fleet.FleetClientMessage"> & {
  /**
   * @generated from field: uint32 message_id = 1;
   */
  messageId: number;

  /**
   * @generated from oneof fleet.FleetClientMessage.payload
   */
  payload: {
    /**
     * @generated from field: fleet.SetViewport set_viewport = 2;
     */
    value: SetViewport;
    case: "setViewport";
  } | {
    /**
     * @generated from field: fleet.Ping ping = 3;
     */
    value: Ping;
    case: "ping";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message fleet.FleetClientMessage.
 * Use `create(FleetClientMessageSchema)` to create a new message.
 */
export const FleetClientMessageSchema: GenMessage<FleetClientMessage> = /*@__PURE__*/
  messageDesc(file_fleet, 5);

/**
 * Server -> Client messages
 *
 * @generated from message fleet.Snapshot
 */
export type Snapshot = Message<"fleet.Snapshot"> & {
  /**
   * @generated from field: repeated fleet.DroneState drones = 1;
   */
  drones: DroneState[];
};

/**
 * Describes the message fleet.Snapshot.
 * Use `create(SnapshotSchema)` to create a new message.
 */
export const SnapshotSchema: GenMessage<Snapshot> = /*@__PURE__*/
  messageDesc(file_fleet, 6);

/**
 * @generated from message fleet.Delta
 */
export type Delta = Message<"fleet.Delta"> & {
  /**
   * @generated from field: repeated fleet.PositionDelta updates = 1;
   */
  updates: PositionDelta[];
};

/**
 * Describes the message fleet.Delta.
 * Use `create(DeltaSchema)` to create a new message.
 */
export const DeltaSchema: GenMessage<Delta> = /*@__PURE__*/
  messageDesc(file_fleet, 7);

/**
 * @generated from message fleet.DroneEntered
 */
export type DroneEntered = Message<"fleet.DroneEntered"> & {
  /**
   * @generated from field: fleet.DroneState drone = 1;
   */
  drone?: DroneState;
};

/**
 * Describes the message fleet.DroneEntered.
 * Use `create(DroneEnteredSchema)` to create a new message.
 */
export const DroneEnteredSchema: GenMessage<DroneEntered> = /*@__PURE__*/
  messageDesc(file_fleet, 8);

/**
 * @generated from message fleet.DroneExited
 */
export type DroneExited = Message<"fleet.DroneExited"> & {
  /**
   * @generated from field: string drone_id = 1;
   */
  droneId: string;
};

/**
 * Describes the message fleet.DroneExited.
 * Use `create(DroneExitedSchema)` to create a new message.
 */
export const DroneExitedSchema: GenMessage<DroneExited> = /*@__PURE__*/
  messageDesc(file_fleet, 9);

/**
 * @generated from message fleet.DroneConnected
 */
export type DroneConnected = Message<"fleet.DroneConnected"> & {
  /**
   * @generated from field: string drone_id = 1;
   */
  droneId: string;
};

/**
 * Describes the message fleet.DroneConnected.
 * Use `create(DroneConnectedSchema)` to create a new message.
 */
export const DroneConnectedSchema: GenMessage<DroneConnected> = /*@__PURE__*/
  messageDesc(file_fleet, 10);

/**
 * @generated from message fleet.DroneDisconnected
 */
export type DroneDisconnected = Message<"fleet.DroneDisconnected"> & {
  /**
   * @generated from field: string drone_id = 1;
   */
  droneId: string;
};

/**
 * Describes the message fleet.DroneDisconnected.
 * Use `create(DroneDisconnectedSchema)` to create a new message.
 */
export const DroneDisconnectedSchema: GenMessage<DroneDisconnected> = /*@__PURE__*/
  messageDesc(file_fleet, 11);

/**
 * @generated from message fleet.FleetAck
 */
export type FleetAck = Message<"fleet.FleetAck"> & {
  /**
   * @generated from field: uint32 original_message_id = 1;
   */
  originalMessageId: number;
};

/**
 * Describes the message fleet.FleetAck.
 * Use `create(FleetAckSchema)` to create a new message.
 */
export const FleetAckSchema: GenMessage<FleetAck> = /*@__PURE__*/
  messageDesc(file_fleet, 12);

/**
 * @generated from message fleet.FleetError
 */
export type FleetError = Message<"fleet.FleetError"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message fleet.FleetError.
 * Use `create(FleetErrorSchema)` to create a new message.
 */
export const FleetErrorSchema: GenMessage<FleetError> = /*@__PURE__*/
  messageDesc(file_fleet, 13);

/**
 * @generated from message fleet.FleetServerMessage
 */
export type FleetServerMessage = Message<"fleet.FleetServerMessage"> & {
  /**
   * @generated from field: uint32 message_id = 1;
   */
  messageId: number;

  /**
   * @generated from field: uint64 timestamp = 2;
   */
  timestamp: bigint;

  /**
   * @generated from oneof fleet.FleetServerMessage.payload
   */
  payload: {
    /**
     * @generated from field: fleet.Snapshot snapshot = 3;
     */
    value: Snapshot;
    case: "snapshot";
  } | {
    /**
     * @generated from field: fleet.Delta delta = 4;
     */
    value: Delta;
    case: "delta";
  } | {
    /**
     * @generated from field: fleet.DroneEntered drone_entered = 5;
     */
    value: DroneEntered;
    case: "droneEntered";
  } | {
    /**
     * @generated from field: fleet.DroneExited drone_exited = 6;
     */
    value: DroneExited;
    case: "droneExited";
  } | {
    /**
     * @generated from field: fleet.DroneConnected drone_connected = 7;
     */
    value: DroneConnected;
    case: "droneConnected";
  } | {
    /**
     * @generated from field: fleet.DroneDisconnected drone_disconnected = 8;
     */
    value: DroneDisconnected;
    case: "droneDisconnected";
  } | {
    /**
     * @generated from field: fleet.FleetAck ack = 9;
     */
    value: FleetAck;
    case: "ack";
  } | {
    /**
     * @generated from field: fleet.FleetError error = 10;
     */
    value: FleetError;
    case: "error";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message fleet.FleetServerMessage.
 * Use `create(FleetServerMessageSchema)` to create a new message.
 */
export const FleetServerMessageSchema: GenMessage<FleetServerMessage> = /*@__PURE__*/
  messageDesc(file_fleet, 14);

/**
 * @generated from message fleet.TelemetryUpdate
 */
export type TelemetryUpdate = Message<"fleet.TelemetryUpdate"> & {
  /**
   * @generated from field: string drone_id = 1;
   */
  droneId: string;

  /**
   * @generated from field: double lat = 2;
   */
  lat: number;

  /**
   * @generated from field: double lng = 3;
   */
  lng: number;

  /**
   * @generated from field: float alt = 4;
   */
  alt: number;

  /**
   * @generated from field: float heading = 5;
   */
  heading: number;

  /**
   * @generated from field: float battery = 6;
   */
  battery: number;

  /**
   * @generated from field: uint64 timestamp = 7;
   */
  timestamp: bigint;
};

/**
 * Describes the message fleet.TelemetryUpdate.
 * Use `create(TelemetryUpdateSchema)` to create a new message.
 */
export const TelemetryUpdateSchema: GenMessage<TelemetryUpdate> = /*@__PURE__*/
  messageDesc(file_fleet, 15);

/**
 * @generated from message fleet.StatusUpdate
 */
export type StatusUpdate = Message<"fleet.StatusUpdate"> & {
  /**
   * @generated from field: string drone_id = 1;
   */
  droneId: string;

  /**
   * @generated from field: bool connected = 2;
   */
  connected: boolean;

  /**
   * @generated from field: uint64 timestamp = 3;
   */
  timestamp: bigint;
};

/**
 * Describes the message fleet.StatusUpdate.
 * Use `create(StatusUpdateSchema)` to create a new message.
 */
export const StatusUpdateSchema: GenMessage<StatusUpdate> = /*@__PURE__*/
  messageDesc(file_fleet, 16);

/**
 * @generated from message fleet.InternalMessage
 */
export type InternalMessage = Message<"fleet.InternalMessage"> & {
  /**
   * @generated from oneof fleet.InternalMessage.payload
   */
  payload: {
    /**
     * @generated from field: fleet.TelemetryUpdate telemetry = 1;
     */
    value: TelemetryUpdate;
    case: "telemetry";
  } | {
    /**
     * @generated from field: fleet.StatusUpdate status = 2;
     */
    value: StatusUpdate;
    case: "status";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message fleet.InternalMessage.
 * Use `create(InternalMessageSchema)` to create a new message.
 */
export const InternalMessageSchema: GenMessage<InternalMessage> = /*@__PURE__*/
  messageDesc(file_fleet, 17);

